export default "__VITE_ASSET__DXr1LTdy__"